import React from 'react';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import PropTypes from 'prop-types';

import { useTrackEventsService } from 'components/Services/Analytics/useTrackEventsService';

const TrackedSubmit = ({ onSubmit, buttonName, submitComponent, submittedValue, ...rest }) => {
  const { trackSelectionSubmitted } = useTrackEventsService();

  let newSubmittedValue = submittedValue;

  if (!Array.isArray(submittedValue)) {
    newSubmittedValue = [submittedValue];
  }
  const onTrackedSubmit = (event) => {
    trackSelectionSubmitted({ buttonName, submittedValue: newSubmittedValue });
    onSubmit(event);
  };
  const SubmitComponent = submitComponent;
  return <SubmitComponent data-testid="tracked-submit" onClick={onTrackedSubmit} {...rest} />;
};

TrackedSubmit.propTypes = {
  onSubmit: PropTypes.func,
  buttonName: PropTypes.string,
  submitComponent: PropTypes.element,
  submittedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf()]),
};

TrackedSubmit.defaultProps = {
  submitComponent: Button,
  onSubmit: () => {},
};

export default TrackedSubmit;
